export enum DocusignContractType {
  TCP = 'TCP',
  SLA_BUYER = 'SLA_BUYER',
  SLA_SELLER = 'SLA_SELLER',
  ANNEX_BUYER = 'ANNEX_BUYER',
  ANNEX_SELLER = 'ANNEX_SELLER',
  DIRECT_PRODUCT = 'DIRECT_PRODUCT',
}
